import styled from 'styled-components';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	position: relative;
	margin: 40px 0;

	${minWidth('desktop')} {
		padding: 60px 0;
	}

	${minWidth('desktop')} {
		padding: 80px 0;
	}
`;

export const Grid = styled(GridWrapper)`
	grid-template-columns: 1fr;

	${minWidth('tablet')} {
		grid-template-columns: 50% 50%;
	}
`;

export const Heading = styled.h1`
	${fontWeight(FontWeights.Regular)}
	margin-bottom: 32px;
	position: relative;

	${minWidth('tablet')} {
		margin-bottom: 28px;
	}

	${minWidth('desktop')} {
		margin-bottom: 48px;
	}

	&:after {
		background-image: url('/_n/images/schools/flourish-arrow.webp');
		background-repeat: no-repeat;
		background-size: contain;
		content: '';
		display: none;
		position: absolute;
		top: 0;
		right: 0;

		${minWidth('desktop')} {
			display: block;
			height: 64px;
			top: 16px;
			width: 100px;
		}
	}
`;

export const ContentWrapper = styled.div``;

export const Benefit = styled.h5`
	${fontWeight(FontWeights.Regular)}
	margin: 40px 0;
`;

export const Photo = styled.div`
	aspect-ratio: 0.92;
	position: relative;
	width: 100%;
`;

export const DesktopCtaButton = styled(Button)`
	display: none;

	${minWidth('tablet')} {
		display: block;
	}
`;

export const MobileCtaButton = styled(Button)`
	margin: 28px auto 0;

	${minWidth('tablet')} {
		display: none;
	}
`;
